import React, { useContext, useEffect } from "react";

import UserMenu from "@layout/header/User/UserMenu";
import { FormTypeEnum } from "@layout/modals/types";
import { setAuthParamToURL } from "@layout/modals/utils";
import { useLocation } from "@reach/router";
import { navigate } from "gatsby";

import { Currency } from "@/autoGeneratedGlobalTypes";
import FreeMinutesDisplay from "@/components/common/freeMinutesDisplay";
import { IconSizeEnum, IconTypeEnum } from "@/components/common/icon";
import { UserAvatar } from "@/components/common/userAvatar";
import GlobalContext from "@/contexts/Global/GlobalContext";
import UserContext from "@/contexts/User/UserContext";
import useProfile from "@/hooks/useProfile";
import { currencyToString } from "@/utils/globalTypesUtils";
import { priceToString } from "@/utils/numberUtils";
import {
  Button,
  ButtonColorEnum,
  ButtonIconPositionEnum,
  ButtonSizeEnum,
} from "@components/common/button";
import Loader from "@components/common/loader";
import { UserAvatarTypeEnum } from "@components/common/userAvatar/types";
import UserInfo from "@components/common/userInfo";

import { userMenuProps } from "./types";

import "./styles.scss";

const User = ({ setRedirectMobileProfile }: userMenuProps) => {
  const { balance, unfinishedPaymentId, isUserLoggedIn, freeMinutesCount } = useContext(UserContext);
  const { isExpert } = useContext(GlobalContext);
  const location = useLocation();
  const {
    fetchProfile,
    profileData: getMyProfileData,
    loading: getMyProfileLoading,
  } = useProfile({ autoFetch: false, fetchPolicy: "network-only", nextFetchPolicy: "cache-first" });

  const onAuthorizationLinkClick = () => {
    setAuthParamToURL(location, FormTypeEnum.Login);
  };

  useEffect(() => {
    fetchProfile();
  }, [fetchProfile]);

  return (
    <div className="header__user-container">
      {getMyProfileData && isUserLoggedIn && !isExpert && (
        <>
          {freeMinutesCount !== 0
            && (
              <div
                onClick={() =>
                  (!isUserLoggedIn ? onAuthorizationLinkClick() : navigate("/profile/balance"))}
              >
                <FreeMinutesDisplay iconSize={IconSizeEnum.Size24} withMinutes />
              </div>
            )}
          <div
            className="header-balance"
            onClick={() =>
              navigate("/profile/payment/")}
          >
            <div className="header-balance__info">
              <div className="header-balance__title">На балансе</div>
              <div className="header-balance__value">
                {unfinishedPaymentId ? (
                  <div className="header__balance-loader">
                    <Loader />
                  </div>
                ) : (
                  <div className="header__balance-amount">
                    {balance ? priceToString(balance.amount) : 0}
                    &nbsp;
                    {balance ? currencyToString(balance.currency) : Currency.RUB}
                  </div>
                )}
              </div>
            </div>
            <Button
              className="header-balance__button"
              aria-label="Пополнить баланс"
              size={ButtonSizeEnum.XSmall}
              color={ButtonColorEnum.Black}
              text="Пополнить"
              onClick={() =>
                navigate("/profile/payment/")}
            />
          </div>
        </>
      )}
      <div className="header__user">
        {isUserLoggedIn && getMyProfileData ? (
          <>
            <div
              className={`header__user-desctop ${isUserLoggedIn ? "header__user--shadow" : ""}`}
            >
              <UserInfo
                avatar={(
                  <UserAvatar
                    mobileImage={getMyProfileData.user.mobileImage}
                    desktopImage={getMyProfileData.user.desktopImage}
                    name={getMyProfileData.user.name}
                    userId={getMyProfileData.user.id}
                    type={UserAvatarTypeEnum.HeaderSmall}
                  />
                )}
              />
              <div className="user-menu__container">
                <UserMenu profileData={getMyProfileData} />
              </div>
            </div>
            <Button
              text="Аккаунт"
              className="header__user-mobile link"
              size={ButtonSizeEnum.Small}
              color={ButtonColorEnum.White}
              icon={IconTypeEnum.User}
              iconPosition={ButtonIconPositionEnum.Left}
              disabled={getMyProfileLoading}
              onClick={() =>
                setRedirectMobileProfile("profile")}
            />
          </>
        ) : (
          <>
            <Button
              text="Войти"
              className="header__login-btn-desctop"
              size={ButtonSizeEnum.Small}
              onClick={onAuthorizationLinkClick}
              disabled={getMyProfileLoading}
            />
            <Button
              text="Войти"
              className="header__login-btn-mobile link"
              size={ButtonSizeEnum.Small}
              color={ButtonColorEnum.White}
              icon={IconTypeEnum.User}
              iconPosition={ButtonIconPositionEnum.Left}
              onClick={onAuthorizationLinkClick}
              disabled={getMyProfileLoading}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default User;
